import React from "react";

import { Footer } from "../../components/Footer";
import { HeaderWrapper } from "../../components/Header/HeaderWrapper";
import { SectionDotNav } from "../../components/Header/Sectiondotnav";
import { AboutUsSection } from "../../components/Page1/AboutUsSection";
import { AppDownloadBannerSection } from "../../components/Page1/AppDownloadBannerSection";
import { AppDownloadBannerSectionSM } from "../../components/Page1/AppDownloadBannerSectionSM";
import { Box } from "../../components/Page1/Box";
import DealsCategoryBannerSection from "../../components/Page1/DealsCategoryBannerSection";
import { HeroSection } from "../../components/Page1/HeroSection";
import { PremiumMembershipBanner } from "../../components/Page1/PremiumMembershipBanner";
import { PremiumMembershipBannerSM } from "../../components/Page1/PremiumMembershipBannerSM";
import { RewardsProgramSection } from "../../components/Page1/RewardsProgramSection";
import SaveRedeemSection from "../../components/Page1/SaveRedeemSection";
import SmartDealsBannerSection from "../../components/Page1/SmartDealsBannerSection";
import { AuthorizedRedirect } from "../../..";

const Page1: React.FC = () => {
  return (
    <div className="w-full bg-transparent overflow-x-hidden min-h-screen">
      <AuthorizedRedirect isCustomer={true} />
      {/* <img
        src="/images/HeroSectionBg.svg"
        className="absolute w-auto h-auto object-cover -top-12"
        alt=""
      /> */}
      <img
          src="/images/Webp/HeroSectionBg.webp"
          className="absolute w-auto h-auto object-cover"
          alt=""
        />
      <HeaderWrapper />
      <SectionDotNav />

      <main className="relative z-10 flex flex-col items-center pt-[140px]">
        
        <div className="absolute inset-0 -z-10" />

        <section id="hero" className="relative w-full flex justify-center z-20">
          <div className="w-full max-w-[1820px] px-[40px] lg:px-[80px]">
            <HeroSection />
          </div>
        </section>

        <section id="smart-deals" className="relative w-full flex justify-center z-10">
          <div className="w-full max-w-[1820px]">
            <SmartDealsBannerSection />
          </div>
        </section>

        <section id="about" className="w-full flex justify-center mt-12">
          <div className="w-full max-w-[1700px]">
            <AboutUsSection />
          </div>
        </section>

        <section id="categories" className="w-full flex justify-center mt-12">
          <div className="w-full max-w-[1700px]">
            <DealsCategoryBannerSection />
          </div>
        </section>

        <section id="personalised" className="w-full flex justify-center mt-24">
          <div className="w-full max-w-[1700px]">
            <Box />
          </div>
        </section>

        <section id="save-redeem" className="w-full flex justify-center mt-24">
          <div className="w-full max-w-[1700px] px-6">
            <SaveRedeemSection />
          </div>
        </section>

        <section id="rewards" className="w-full flex justify-center">
          <div className="w-full max-w-[1700px]">
            <RewardsProgramSection />
          </div>
        </section>

        <section id="premium" className="w-full flex justify-center">
          <div className="w-full max-w-[1700px] hidden lg:block">
            <PremiumMembershipBanner />
          </div>
          <div className="w-full max-w-[1700px] lg:hidden">
            <PremiumMembershipBannerSM />
          </div>
        </section>

        <section id="download" className="w-full flex justify-center mb-12">
          <div className="w-full max-w-[1700px] px-6 hidden lg:block">
            <AppDownloadBannerSection />
          </div>
          <div className="w-full max-w-[1700px] lg:hidden">
            <AppDownloadBannerSectionSM />
          </div>
        </section>

      </main>
    </div>
  );
};

export default Page1;